import { useAuthContext } from "../context/AuthContext";

/**
 * Auth state and helpers. Uses AuthContext so /me is called only once per app load
 * instead of once per component that calls useAuth().
 */
export default function useAuth() {
  return useAuthContext();
}
